export default "__VITE_ASSET__cI1fr8Zf__"